import api from '@/api'

const { $pricing, $core, $academic } = api;
const $st = api.$student

export const { $processings, $cities, $states, $citiesByState } = $core
export const { $changeCareerContract, $studentByIdentification, $studentProcessing, $materias, $studentAccount, $student, $students, $reEnrollment, $finalExam , $examenes, $generateDuesAccount} = $st
export const { $ceos, $terms, $careers, $studyPlans, $setting } = $academic
export const { $types, $tneProducts, $billingProps, $productWithPrice, $discounts, $benefits, $scholarships, $titleExam, $communities, $productsWithPricePeriods } = $pricing
